import React from "react";
import Modal from "../../Atoms/Modal/Modal";
import Buttons from "../../Atoms/Buttons/Buttons";
import styles from "../../Atoms/Modal/Modal.module.scss";
import { sanitizeAndValidateUrl } from "../../../app/helpers/sanitizeAndValidateUrl";

const UserModal = ({
  handleOnClose,
  selectedDetails,
  handleEdit,
  handleDelete,
  selectedItem,
  setDeleteMode,
}) => {
  //------------------------------------------------------

  return (
    <Modal onClose={handleOnClose} closeWhite={false}>
      <div className={styles['viewEG-container']}>
        <img
          src={sanitizeAndValidateUrl(
            selectedDetails.url + selectedDetails.magazineThumbnail
          )}
          alt="0"
        />
        <div className={styles.detailsContainer}>
          <h3>
            <span className={styles.label}>تاريخ النشر: </span>
            <span className={styles.value}>
              {selectedDetails.magazineDate.substring(0, 10)}
            </span>
          </h3>
          <h3>
            <span className={styles.label}>الإصدار: </span>
            <span className={styles.value}>
              {selectedDetails.editionNumber}
            </span>
          </h3>
          <h3>
            <span className={styles.label}>عدد الصفحات: </span>
            <span
              className={styles.value}
            >{`${selectedDetails.pageNumber} صفحات`}</span>
          </h3>
        </div>
        <div className={styles['button-input-container']}>
          <Buttons
            text="تعديل"
            color="rgba(13, 160, 110, 1)"
            handleOnClick={handleEdit}
            rounded
            width={250}
          />{' '}
          <Buttons
            text="حذف"
            color="#D72222"
            handleOnClick={() => setDeleteMode(true)}
            rounded
            width={250}
          />
        </div>
      </div>
    </Modal>
  );
};

export default UserModal;
